import clsx from "clsx";
import React from "react";
import "./analyticsCardTitle.scss";

interface IAnalyticsCardTitleProps extends React.ComponentPropsWithoutRef<"h2"> { }

export const AnalyticsCardTitle = (props: IAnalyticsCardTitleProps) => {
    return <h2 {...props} className={clsx("analytics-card-title", props.className)} />;
};
